import { FC } from "react";
import Script from "next/script";
interface Props {
  url?: string;
}

const TikTok: FC<Props> = ({ url }) => {
  if (!url) {
    return null;
  }
  return (
    <>
      <Script async src="https://www.tiktok.com/embed.js"></Script>
      <blockquote
        className="tiktok-embed"
        cite={url}
        data-video-id={url.toString().split("/")[5]}
        style={{ minWidth: "100%" }}
      >
        <section>
          {" "}
          <a target="_blank"  rel="noreferrer"  href={url}></a>{" "}
        </section>{" "}
      </blockquote>
    </>
  );
};

export default TikTok;
